import GeneralSetting from "./general-setting.container";

export default GeneralSetting;
